import { Routes } from '@angular/router';
import { GlobalConstants, TERMINOLOGY } from './global-constants';
import { lcTemplate } from './template/lc-template';
import { projectCompleteGuard } from './shared/projects/project-complete.guard';
import { authGuard } from './shared/auth/auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
    title: `Sign In | ${GlobalConstants.appInfo.appName}`,
  },
  {
    path: 'login/callback',
    loadComponent: () => import('./pages/login/callback').then((m) => m.LoginCallback),
    title: `Completing Sign In | ${GlobalConstants.appInfo.appName}`,
  },
  {
    path: 'logged-out',
    loadComponent: () => import('./pages/login/logged-out').then((m) => m.LoggedOut),
    title: `Signed Out | ${GlobalConstants.appInfo.appName}`,
  },
  {
    path: 'home',
    component: lcTemplate,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home').then((m) => m.Home),
        title: `${TERMINOLOGY.entityPlural} | ${GlobalConstants.appInfo.appName}`,
      },
    ],
  },
  {
    path: 'files/new',
    component: lcTemplate,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/upload-file/upload-file').then((m) => m.UploadFile),
        title: `New ${TERMINOLOGY.entity} | ${GlobalConstants.appInfo.appName}`,
        // Draft changes persist during the wizard; only locally dirty changes
        // require confirmation before leaving.
        canDeactivate: [
          (component: { canLeave(): Promise<boolean> }) => component.canLeave(),
        ],
      },
    ],
  },
  {
    path: 'files/:id/edit',
    component: lcTemplate,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/upload-file/upload-file').then((m) => m.UploadFile),
        title: `Edit ${TERMINOLOGY.entity} | ${GlobalConstants.appInfo.appName}`,
        canDeactivate: [
          (component: { canLeave(): Promise<boolean> }) => component.canLeave(),
        ],
      },
    ],
  },
  {
    path: 'files/:id/review',
    component: lcTemplate,
    canActivate: [authGuard, projectCompleteGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'table',
      },
      {
        path: 'table',
        loadComponent: () =>
          import('./pages/review/table-review/table-review').then((m) => m.TableReview),
        title: `${TERMINOLOGY.entity} Details | ${GlobalConstants.appInfo.appName}`,
      },
    ],
  },
  {
    path: 'redis-stats',
    component: lcTemplate,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/redis-stats/redis-stats').then((m) => m.RedisStats),
        title: `Redis Cache Statistics | ${GlobalConstants.appInfo.appName}`,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];
